import Image from 'next/image'

import styles from './PangeaWidget.module.scss'

import socialUrls from 'constants/socialUrls'
import Link from 'next/link'

const PangeaWidget = () => (
  <div className={styles.container}>
    <Link href={socialUrls.pangea} rel='nofollow' title='Hire elite software development vendors at Pangea'>
      <Image src='/assets/logo_pangea.svg' className={styles.logo} alt='' width={140} height={50} priority={true} unoptimized={true} />
    </Link>
  </div>
)

export default PangeaWidget
